import React, { useCallback, useEffect, useState } from "react";
import { Alert, Text } from "@catchoftheday/cg-components";
import { ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY, ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY } from "@catchoftheday/common-vendors";
import { emitMigrationFlashMessageImpression } from "@catchoftheday/analytics";
import { getQueryStringValue } from "@header-app/utilities";
import { FLASH_BANNER_MIGRATION_ERROR_MSG, FLASH_BANNER_MIGRATION_SUCCESS_MSG, FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG } from "@header-app/consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var FlashMessageBanner = function FlashMessageBanner() {
  var _useState = useState(false),
      showAlert = _useState[0],
      setShowAlert = _useState[1];

  var _useState2 = useState("default"),
      variant = _useState2[0],
      setVariant = _useState2[1];

  var _useState3 = useState(),
      bannerMessage = _useState3[0],
      setBannerMessage = _useState3[1];

  var paramMigrationDoubleSubs = getQueryStringValue(ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY);
  var paramMigrationStatus = getQueryStringValue(ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY);
  useEffect(function () {
    handleOnePassMigrationMessages();
  }, []);
  useEffect(function () {
    if (bannerMessage) {
      setShowAlert(true);
    }
  }, [bannerMessage]);
  var hideAlert = useCallback(function () {
    setShowAlert(false);
    setBannerMessage("");
  }, []);

  var handleOnePassMigrationMessages = function handleOnePassMigrationMessages() {
    var _window, _window$location;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) === "/search") {
      if (paramMigrationStatus === "done") {
        var msg = paramMigrationDoubleSubs === "1" ? FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG : FLASH_BANNER_MIGRATION_SUCCESS_MSG;
        setVariant("success");
        setBannerMessage(msg);
        setTimeout(function () {
          emitMigrationFlashMessageImpression({
            type: "success",
            message: msg
          });
        }, 1000);
      } else if (paramMigrationStatus === "error") {
        setVariant("error");
        setBannerMessage(FLASH_BANNER_MIGRATION_ERROR_MSG);
        setTimeout(function () {
          emitMigrationFlashMessageImpression({
            type: "error",
            message: FLASH_BANNER_MIGRATION_ERROR_MSG
          });
        }, 1000);
      }
    }
  };

  return ___EmotionJSX(React.Fragment, null, showAlert && bannerMessage && ___EmotionJSX(Alert, {
    type: "inline",
    theme: "dark",
    variant: variant,
    showAlertIcon: false,
    showCloseButton: true,
    hideAlert: hideAlert
  }, ___EmotionJSX(Text, {
    fontSize: {
      xs: "sm",
      md: "base"
    },
    fontWeight: 400,
    my: 0
  }, bannerMessage)));
};